import axios from "axios";

const isProd = import.meta.env.MODE === "production";

// In production, use current site origin so API matches frontend domain
const API_BASE_URL = isProd
  ? window.location.origin
  : "http://localhost:5122";


const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true
});

export default api;
